import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { filterOptions, sortingOptions } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/Dropdown/constants.js';
import { Select } from '../../../../../../primitives/index.js';
export const RatingDropdown = ({
  onDropdownChange,
  method,
  singleItem
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  const mdUp = useBreakpointUp('md');
  const defaultDropdownValue = method === 'filters' ? filterOptions(t).find(filter => filter.value === 'all') : sortingOptions(t).find(filter => filter.value === 'latest');
  const dropdownOptions = method === 'filters' ? filterOptions(t) : sortingOptions(t);
  const dropdownPrefix = method === 'filters' ? t('amadeusRatingSection.filters.label') : t('amadeusRatingSection.sorting.label');
  const handleMenuOpen = () => {
    const container = document.getElementById('dialog-content');
    if (container) {
      container.scrollTop = 550;
    }
  };
  return _jsx(Select
  // @ts-expect-error TS(2322) FIXME: Type '{ ref: MutableRefObject<null>; placeholder: ... Remove this comment to see the full error message
  , {
    // @ts-expect-error TS(2322) FIXME: Type '{ ref: MutableRefObject<null>; placeholder: ... Remove this comment to see the full error message
    defaultValue: defaultDropdownValue,
    isSearchable: false,
    menuShouldScrollIntoView: false,
    menuPlacement: singleItem ? 'top' : 'bottom',
    onMenuOpen: method === 'sorting' ? handleMenuOpen : undefined,
    options: dropdownOptions,
    formatSingleValue: state => ({
      prefix: mdUp ? dropdownPrefix : '',
      value: state.data.label
    }),
    highlightBehaviour: "always",
    // @ts-expect-error ...
    onChange: ({
      value
    }) => {
      onDropdownChange(value);
    },
    fullWidth: true
  });
};